import { useLogout } from "lib/api-auth";
import { Link, useLocation } from "react-router-dom";
import {
    Navbar,
    Nav,
    Container,
    Button,
} from "reactstrap";

const AdminNavbar = (props) => {
    const { mutate: logout } = useLogout();
    const { pathname } = useLocation();
    const lastSegment = pathname.split("/").filter(Boolean).pop() || "";
    const displayText = lastSegment === "index" ? "dashboard" : lastSegment;

    const handleLogout = () => {
        logout(null, {
            onSuccess: () => {
                window.location.href = "/auth/login";
            },
        });
    };
    return (
        <>
            <Navbar
                className="navbar-top navbar-dark"
                expand="md"
                id="navbar-main"
            >
                <Container fluid>
                    <Link
                        className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
                        to="/"
                    >
                        {displayText || "dashboard"} {/* Fallback to "dashboard" if empty */}
                    </Link>
                    <Nav className="align-items-center d-none d-md-flex" navbar>
                        <Button
                            color="warning"
                            href="#pablo"
                            onClick={() => handleLogout()}
                        >
                            Logout
                        </Button>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
};

export default AdminNavbar;